import { Button, Dialog, DialogContent, Typography, TextField } from "@mui/material";
import React, { useState } from "react";
import RefIndexMasking from "./RefIndexMasking";
import HistoricalData from "./HistoricalData";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { url } from "../../api/axios_client";
import axios from "../../api/axios_client";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";
import CurrentData from "./CurrentData";
import "./style.css";
import ResultComponent from "./ResultComponent";
import GraphComponent from "./GraphComponent";
import { TrophySpin } from "react-loading-indicators";
import zScoreLegend from "./Z-Score-vert.png";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { DatePicker } from "@mui/lab";
import ReportPreview from "../../components/ReportPreview";
const MonitoringDialog = ({ mainIndex, open, handleClose }) => {
  const getIndexesFromCategories = () => {
    try {
      const categoriesStr = localStorage.getItem('categories');
      if (!categoriesStr) return [];

      const categories = JSON.parse(categoriesStr);
      // Map categories to required format
      return categories.map(category => ({
        id: category.id,
        name: category.name,
        key: category.name.toLowerCase(), // or use category.type if you prefer
        available_from: category.available_from,
        available_to: category.available_to
      }));
    } catch (error) {
      console.error('Error parsing categories from localStorage:', error);
      return [];
    }
  };

  const indexes = getIndexesFromCategories();
  const dialogStyle = {
    position: "absolute",
    top: 0,
    right: 0,
    height: "100%",
    width: "100%",
    margin: "0",
    textAlign: 'left',
    direction: 'ltr',
  };

  const [responseData, setresponseData] = useState(null);
  const [loading, setloading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [additionalInformation, setAdditionalInformation] = useState('');
  const [additionalInformationAr, setAdditionalInformationAr] = useState('');
  const RefIndex = useSelector((state) => state.maskingState.RefIndex);
  const validateData = () => {
    // area
    if (!areas || !areas[0] || !areas[0].coordinates) {
      toast.error("Please select the area you want to be monitored");
      return false;
    }
    // historical data check
    if (!mainIndex || mainIndex.length === 0) {
      toast.error("Please select the main index for Masking");
      return false;
    } else if (!mainShortTermMonitoring && mainIndex !== "reporting" && mainIndex !== "all") {
      console.log("mainShortTermMonitoring", mainShortTermMonitoring);
      toast.error(
        "Please select short term monitoring year for historical index"
      );
      return false;
    }

    // added index validation
    for (let histDataLoop of addedIndexes) {
      // Check if index is selected (not empty)
      if (!histDataLoop.name || histDataLoop.name === "") {
        toast.error("Please select the name for your historical index");
        return false;
      }

      // Check date range validation
      if (!histDataLoop.from_date || !histDataLoop.to_date) {
        toast.error("Please select date range for historical index");
        return false;
      }

      // Filter validation with minimum constraints
      if (histDataLoop.filterToggle) {
        const window = parseInt(histDataLoop.window);
        const order = parseInt(histDataLoop.order);

        if (!histDataLoop.order || !histDataLoop.window ||
          histDataLoop.window === "" || histDataLoop.order === "") {
          toast.error("Please select filter values for historical data");
          return false;
        }

        // Minimum days = 3
        if (window < 3) {
          toast.error("Minimum days should be 3 or more");
          return false;
        }

        // Minimum order = 1
        if (order < 1) {
          toast.error("Minimum order should be 1 or more");
          return false;
        }

        // Order should be < days
        if (order >= window) {
          toast.error("Order should be less than days");
          return false;
        }
      }

      if (!histDataLoop.shortTermMonitoring) {
        toast.error(
          "Please select short term monitoring year for historical index"
        );
        return false;
      }
    }

    // Main index date validation for non-all/non-reporting
    if (mainIndex !== "all" && mainIndex !== "reporting") {
      if (!datePickerTimeFrom || !datePickerTimeTo) {
        toast.error("Please select date range for the main index");
        return false;
      }

      // Main filter validation with minimum constraints
      if (mainFilterToggle) {
        const window = parseInt(mainWindowSize);
        const order = parseInt(mainOrder);

        // Minimum days = 3
        if (window < 3) {
          toast.error("Minimum days should be 3 or more");
          return false;
        }

        // Minimum order = 1
        if (order < 1) {
          toast.error("Minimum order should be 1 or more");
          return false;
        }

        // Order should be < days
        if (order >= window) {
          toast.error("Order should be less than days");
          return false;
        }
      }
    }

    // current
    for (let currentAllLoop of currentAll) {
      if (currentAllLoop.filterToggle) {
        const window = parseInt(currentAllLoop.window);
        const order = parseInt(currentAllLoop.order);

        if (!currentAllLoop.order || !currentAllLoop.window ||
          currentAllLoop.window === "" || currentAllLoop.order === "") {
          toast.error("Please select filter values for current data");
          return false;
        }

        // Minimum days = 3
        if (window < 3) {
          toast.error("Minimum days should be 3 or more");
          return false;
        }

        // Minimum order = 1
        if (order < 1) {
          toast.error("Minimum order should be 1 or more");
          return false;
        }

        // Order should be < days
        if (order >= window) {
          toast.error("Order should be less than days");
          return false;
        }
      }
    }

    const isValidDate = (date) => {
      if (!date) return false;
      if (typeof date === 'object' && Object.keys(date).length === 0) return false;
      return true;
    };

    // ref/mask validation
    if (refToggle) {
      // Check if mask index is selected (not empty)
      if (!refData.id && !refData.uploaded) {
        toast.error("Please select the reference index for Masking");
        return false;
      }

      // If masking is toggled, date range is required
      if (!isValidDate(refFromDate) || !isValidDate(refToDate)) {
        toast.error("Please select date range for the masking index");
        return false;
      }

      // Updated error message
      if (rangePairs.length <= 0 && values.length <= 0) {
        toast.error("Please select at least one range or value for masking");
        return false;
      }
    }

    return true; // All validations passed
  };

  //   submit
  const areas = useSelector((state) => state.mapState.areas);

  // ref index

  const rangePairs = useSelector((state) => state.maskingState.rangePairs);
  const values = useSelector((state) => state.maskingState.values);
  const refToggle = useSelector((state) => state.maskingState.refToggle);

  const [sliderPage, setsliderPage] = useState({
    historical: true,
    mask: false,
    additionalInfo: false,
    result: false,
  });

  const handleRight = () => {
    setsliderPage((prevSliderPage) => {
      let nextSliderPage = { ...prevSliderPage };
      const allPages = Object.keys(nextSliderPage);

      // Filter out additionalInfo page if mainIndex is not "reporting"
      const availablePages = mainIndex === "reporting"
        ? allPages
        : allPages.filter(page => page !== 'additionalInfo');

      const currentPageIndex = availablePages.findIndex((page) => nextSliderPage[page]);

      if (currentPageIndex === availablePages.length - 1) {
        return prevSliderPage;
      }

      // Set the current page to false
      nextSliderPage[availablePages[currentPageIndex]] = false;

      // Set the next page to true
      nextSliderPage[availablePages[currentPageIndex + 1]] = true;

      return nextSliderPage;
    });
  };

  const handleLeft = () => {
    setsliderPage((prevSliderPage) => {
      let nextSliderPage = { ...prevSliderPage };
      const allPages = Object.keys(nextSliderPage);

      // Filter out additionalInfo page if mainIndex is not "reporting"
      const availablePages = mainIndex === "reporting"
        ? allPages
        : allPages.filter(page => page !== 'additionalInfo');

      const currentPageIndex = availablePages.findIndex((page) => nextSliderPage[page]);

      if (currentPageIndex === 0) {
        return prevSliderPage;
      }

      // Set the current page to false
      nextSliderPage[availablePages[currentPageIndex]] = false;

      // Set the previous page to true
      nextSliderPage[availablePages[currentPageIndex - 1]] = true;

      return nextSliderPage;
    });
  };
  const handleSubmit = async () => {
    try {
      if (!validateData()) {
        setloading(false);
        return;
      }
      setSubmitted(true);
      setloading(true);

      // Create FormData object
      const formData = new FormData();

      // Add the file if mask upload is enabled
      if (uploadMaskToggle && maskingFileContent) {
        formData.append('mask_file', maskingFileContent);
      }

      // Create the JSON payload
      const jsonData = {
        mask: {
          ...refData,
          // Remove the actual file from JSON since we're sending it separately
          upload_tif: null
        },
        historicalData: historicalData,
        current: historicalData,
        coords: Array.isArray(areas[0].coordinates) ? areas[0].coordinates : null,
        geo: Array.isArray(areas[0].coordinates) ? null : JSON.stringify(areas[0].coordinates),
        ...(mainIndex === "reporting" && {
          additional_information: additionalInformation || '',
          additional_information_ar: additionalInformationAr || '',
        }),
        source: mainIndex === "reporting" ? "reporting" : "monitoring"
      };

      // Add the JSON data as a string
      formData.append('json_data', JSON.stringify(jsonData));

      console.log("formData", formData)

      const res = await axios.post(`${url}/monitoring/monitoring`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
      });


      if (res.status === 200) {
        let result = await res.data;
        console.log("result", result.data);
        if (result && result.data) {
          toast.success("Report generated successfully");
          setresponseData(result);
        } else {
          toast.error("Something went wrong");
        }
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
    } finally {
      setloading(false);
    }
  };
  // const validateData = () => {
  //   if (!mainIndex || mainIndex.length === 0) {
  //     toast.error("please select the main index for Masking");
  //     return false;
  //   } else if (!refIndex || refIndex.length === 0) {
  //     toast.error("please select the ref index for Masking");
  //     return false;
  //   } else if (selectedMain.length === 0) {
  //     toast.error("please select the main index images ");
  //     return false;
  //   } else if (selectedRef.length === 0) {
  //     toast.error("please select the ref index images ");
  //     return false;
  //   } else if (rangePairs.length === 0 && values.length === 0) {
  //     toast.error("please select range or values ");
  //     return false;
  //   } else if (!areas || !areas[0] || !areas[0].coordinates) {
  //     toast.error("please select the polygon you want to be predicted ");
  //     return false;
  //   }

  //   return true;
  // };

  // historical data
  const mainSummerizeOption = useSelector(
    (state) => state.maskingState.mainSummerizeOption
  );
  const currentIndexId = localStorage.getItem('currentIndexId');

  const mainPeriodOfTime = useSelector(
    (state) => state.maskingState.mainPeriodOfTime
  );

  const monthFrom = useSelector(
    (state) => state.maskingState.selectedMonthFrom
  );
  const monthTo = useSelector((state) => state.maskingState.selectedMonthTo);
  const dayFrom = useSelector((state) => state.maskingState.selectedDayFrom);
  const dayTo = useSelector((state) => state.maskingState.selectedDayTo);
  const yearFrom = useSelector((state) => state.maskingState.selectedYearFrom);
  const yearTo = useSelector((state) => state.maskingState.selectedYearTo);
  const addedIndexes = useSelector((state) => state.maskingState.addedIndexes);
  const mainOrder = useSelector((state) => state.maskingState.mainOrder);
  const mainWindowSize = useSelector(
    (state) => state.maskingState.mainWindowSize
  );
  const mainShortTermMonitoring = useSelector(
    (state) => state.maskingState.mainShortTermMonitoring
  );
  const mainFilterToggle = useSelector(
    (state) => state.maskingState.mainFilterToggle
  );
  const mainTemporalMethod = useSelector(
    (state) => state.maskingState.mainTemporalMethod
  );
  const datePickerTimeFrom = useSelector(
    (state) => state.maskingState.selectedFromDate
  );
  const datePickerTimeTo = useSelector(
    (state) => state.maskingState.selectedToDate
  );
  const historicalData = mainIndex === "all" || mainIndex === "reporting" ? [...addedIndexes] : [
    {
      id: currentIndexId,
      name: mainIndex,
      from_date: datePickerTimeFrom,
      to_date: datePickerTimeTo,
      yearFrom: yearFrom,
      yearTo: yearTo,
      filterToggle: mainFilterToggle,
      order: mainOrder,
      window: mainWindowSize,
      periodOfTime: mainPeriodOfTime,
      summerizeOptions: mainSummerizeOption,
      shortTermMonitoring: mainShortTermMonitoring,
      mainTemporalMethod: mainTemporalMethod,
    },
    ...addedIndexes,
  ];
  console.log("historical", historicalData);

  // current data
  const currentAll = useSelector((state) => state.maskingState.currentAll);
  console.log("current", currentAll);

  // masking \ ref data
  const refFromDate = useSelector((state) => state.maskingState.refFromDate);
  const refToDate = useSelector((state) => state.maskingState.refToDate);
  const monthFromref = useSelector((state) => state.maskingState.refMonthFrom);
  const monthToref = useSelector((state) => state.maskingState.refMonthTo);
  const dayFromref = useSelector((state) => state.maskingState.refDayFrom);
  const dayToref = useSelector((state) => state.maskingState.refDayTo);
  const yearFromref = useSelector((state) => state.maskingState.refYearFrom);
  const yearToref = useSelector((state) => state.maskingState.refYearTo);
  const maskingFileContent = useSelector((state) => state.mapState.maskingFileContent);
  const uploadMaskToggle = useSelector((state) => state.maskingState.uploadMaskToggle);
  const refData = {
    uploaded: uploadMaskToggle,
    upload_container: uploadMaskToggle ? "mask_container" : null,
    upload_tif: uploadMaskToggle ? maskingFileContent : null,
    id: uploadMaskToggle ? null : RefIndex[0],
    range: rangePairs,
    values: values,
    from_date: uploadMaskToggle ? {} : refFromDate,
    to_date: uploadMaskToggle ? {} : refToDate,
    refToggle: refToggle
  };
  console.log("ref Data", refData);
  console.log("ref INDEX", RefIndex);

  console.log("response data", responseData);

  return (
    <Dialog
      open={open}
      fullScreen
      onClose={handleClose}
      PaperProps={{ sx: dialogStyle, style: { maxHeight: "None" } }}
      className="animated-dialog"
    >
      <DialogContent>
        {/* Content of your side modal goes here */}
        <CloseIcon
          sx={{
            cursor: "pointer",
            position: "absolute",
            right: "15px",
            color: "#329ace",
          }}
          onClick={handleClose}
        />

        <div className="pred-right-arrow" onClick={handleRight} dir="ltr">
          <span>Next</span> <ArrowForwardIosIcon />
        </div>
        <div className="pred-left-arrow" onClick={handleLeft} dir="ltr">
          <ArrowBackIosIcon /> <span>Previous</span>
        </div>
        {/* main index */}
        <div
          style={{
            display: sliderPage.historical ? "flex" : "none",
          }}
          className="monitoring-historical-container"
        >
          <HistoricalData mainIndex={mainIndex} indexes={indexes} />
        </div>
        <br />
        {/* {sliderPage.current && (
          <div
            style={{
              display: sliderPage.current ? "flex" : "none",
            }}
            className="monitoring-historical-container"
          >
            <CurrentData mainIndex={mainIndex} indexes={indexes} />
          </div>
        )} */}
        {/* ref index */}
        <div
          className="pred-main-container"
          style={{
            display: sliderPage.mask ? "flex" : "none",
          }}
        >
          <RefIndexMasking refToggle={refToggle} indexes={indexes} />
          <br />
          {/* Range of values */}
        </div>
        {/* Additional Information page */}
        {mainIndex === "reporting" &&
          <div
            style={{
              display: sliderPage.additionalInfo ? "flex" : "none",
              justifyContent: 'center',
              alignItems: 'center',
            }}
            className="pred-main-container"
          >
            <div style={{ width: '100%', padding: '20px' }}>
              <Typography variant="h6" gutterBottom>
                Additional Information
              </Typography>

              <TextField
                label="Additional Information"
                multiline
                rows={7}
                fullWidth
                variant="outlined"
                value={additionalInformation}
                onChange={(e) => setAdditionalInformation(e.target.value)}
                placeholder="Enter any additional information..."
                inputProps={{ maxLength: 2000 }}
                style={{ marginBottom: '20px' }}
                helperText={`${additionalInformation.length}/2000`}
              />

              <TextField
                label="معلومات إضافية"
                multiline
                rows={7}
                fullWidth
                variant="outlined"
                value={additionalInformationAr}
                onChange={(e) => setAdditionalInformationAr(e.target.value)}
                placeholder="أدخل أي معلومات إضافية..."
                inputProps={{ maxLength: 2000, dir: 'rtl' }}
                style={{ marginBottom: '20px' }}
                helperText={`${additionalInformationAr.length}/2000`}
              />
            </div>
          </div>}
        <br />
        {/* result */}
        <div
          style={{
            display: sliderPage.result ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="pred-main-container"
        >
          {/* submit btn */}
          <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            {mainIndex === "reporting" && (
              <Button
                variant="contained"
                color="primary"
                target="_blank"
                rel="noopener noreferrer"
                className='pred-download-button'
                style={{ alignSelf: "center", width: "54em" }}
                disabled={historicalData.length > 0 ? false : true}
                onClick={handleSubmit}
              >
                {responseData && responseData.data ? `Re-generate Monitorting Report` : `Generate Monitorting Report`}
              </Button>
            )}
            {loading ? (
              <TrophySpin color="#3154cc" size="medium" text="" textColor="" />
            ) : mainIndex !== "reporting" && (
              <Button
                variant="contained"
                onClick={handleSubmit}
                // className="submit-compare-buttons"
                disabled={false}
              // TO DO change disabled to function
              >
                {submitted ? "Resubmit" : "Submit"}
              </Button>
            )}
          </div>
          {/* <div>
            <div>
              {maskingData && maskingData.png && maskingData.png !== "" && (
                <>
                  <Typography fontSize={24} color={"grey"}>
                    Result Image
                  </Typography>
                  <br />
                  <PhotoProvider>
                    <PhotoView src={`data:image/png;base64,${maskingData.png}`}>
                      <img
                        className="masking-image-result"
                        src={`data:image/png;base64,${maskingData.png}`}
                        alt="masked"
                      />
                    </PhotoView>
                  </PhotoProvider>
                </>
              )}
            </div>

            <br />
            {maskingData && maskingData.min && maskingData.min !== "" && (
              <ChartComponent
                min={maskingData.min}
                max={maskingData.max}
                mean={maskingData.mean}
                std={maskingData.std}
              />
            )}

            <br />
            {maskingData && maskingData.url && maskingData.url !== "" && (
              <a className="masking-url-downloadable" href={maskingData.url}>
                {" "}
                Download Tiff Image{" "}
              </a>
            )}
          </div> */}
          {mainIndex === "reporting" && responseData && responseData.data && (
            <div style={{
              width: "100%",
              height: "100%",
              marginTop: "10%"
            }}>
              <ReportPreview source={mainIndex} data={responseData.data} />
            </div>
          )}

          <br />
          {mainIndex !== "reporting" && responseData &&
            responseData.data.map((data, index) => {
              return (
                <>
                  <div
                    key={index}
                    style={{
                      width: "100%",
                    }}
                  >
                    {mainFilterToggle ? (
                      <ResultComponent
                        curentTime={data.current.time}
                        histTime={data.historical.time}
                        shortTime={data.short_term.time}
                        xAxis={data.x_axis}
                        name={`${data.name} Filtered`}
                        id={`chart-container-filtered-${index}}`} // Pass unique id here
                        current={data.current}
                        historical={data.historical}
                        shortTerm={data.short_term}
                        unit={data.unit}
                        filterToggle={true}
                      />
                    ) : (
                      <ResultComponent
                        curentTime={data.current}
                        histTime={data.historical}
                        shortTime={data.short_term}
                        xAxis={data.x_axis}
                        name={data.name}
                        id={`chart-container-${index}`} // Pass unique id here
                        current={data.current}
                        historical={data.historical}
                        shortTerm={data.short_term}
                        unit={data.unit}
                        filterToggle={false}
                      />
                    )}
                    <br />
                    <br />
                    <div className="monitoring-z-score-container">
                      <div className="monitoring-z-score-legend-container">
                        <Typography className="monitoring-z-score-legend-title">Z-Score Legend</Typography>
                        <PhotoProvider>
                          <PhotoView src={zScoreLegend}>
                            <img
                              className="monitoring-z-score-legend-img"
                              src={zScoreLegend}
                              alt="z-score-legend"
                            />
                          </PhotoView>
                        </PhotoProvider>
                      </div>
                      <div
                        className="no-scrollbar z-score-sections-container"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "2rem",
                          overflow: "auto"
                        }}
                      >
                        {/* Historical Z-Score Section */}
                        <div style={{ flex: 1 }}>
                          <Typography className="monitoring-z-score-legend-title">
                            Historical Z-Score
                          </Typography>
                          <div className="z-score-container-scroll">
                            {data.z_score &&
                              data.z_score.map((graph, index) => {
                                return <GraphComponent key={index} graph={graph} />;
                              })}
                          </div>
                        </div>

                        {/* Short-term Z-Score Section */}
                        <div style={{ flex: 1 }}>
                          <Typography className="monitoring-z-score-legend-title">
                            Short term z-Score
                          </Typography>
                          <div className="z-score-container-scroll">
                            {data.z_score_st &&
                              data.z_score_st.map((graph, index) => {
                                return <GraphComponent key={index} graph={graph} />;
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>
                  <br />
                  <br />
                </>
              );
            })}
          <br />
        </div>
        <br />
      </DialogContent>
    </Dialog>
  );
};

export default MonitoringDialog;
